<template>
  <footer id="SiteFooter" class="site-footer-2" :class="isHome ? 'site-footer-home6 site-footer-home2 ' : 'site-footer  bg-gradient-2'">
    <div class="main-footer">
      <div class="container">
        <div class="site-footer--wrapper row q-col-gutter-lg">
          <div class="col-12 col-sm-6 col-lg-4">
            <div class="footer-widget">
              <h5 class="text-h5">Faydalı Linkler</h5>
              <div class="q-mr-xl">
                <q-separator color="grey-7" class="q-mb-xl" />
              </div>
              <ul class="ft-menu-list">
                <li class="ft-menu-item" :key="key" v-for="(nav, key) in footerNav.our_services.child">
                  <a :href="`${siteAddress}${nav.link.startsWith('/') ? '' : '/'}${nav.link}`">
                    <q-icon name="chevron_right" size="1.5rem" class="q-mr-sm" />
                    {{ nav.name }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <div class="footer-widget">
              <h5 class="text-h5">Hızlı Erişim</h5>
              <div class="q-mr-xl">
                <q-separator color="grey-7" class="q-mb-xl" />
              </div>
              <ul class="ft-menu-list">
                <li class="ft-menu-item" :key="key" v-for="(nav, key) in footerNav.sources.child">
                  <a :href="`${siteAddress}${nav.link.startsWith('/') ? '' : '/'}${nav.link}`">
                    <q-icon name="chevron_right" size="1.5rem" class="q-mr-sm" />
                    {{ nav.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-12 lg-hide xl-hide xs-hide q-mt-lg"></div>
          <div class="col-12 col-sm-12 col-lg-4">
            <div class="footer-widget">
              <h5 class="text-h5">Bize Ulaşın</h5>
              <div class="q-mr-xl">
                <q-separator color="grey-7" class="q-mb-xl" />
              </div>
              <div class="site-header--social-platforms">
                <a
                  :key="key"
                  v-for="(social, key) in siteSocialInfo"
                  class="social"
                  :class="{ [`social-${key}`]: social }"
                  :style="{ backgroundImage: `url(/img/social-${key}.svg)` }"
                  :href="social.link"
                >
                  <span style="display: none">{{ social.name }}</span>
                </a>
              </div>
              <!--              <div class="elfsight-app-28bcc7c1-bd6f-4d03-a578-317a16d8b949"></div>-->
              <p class="q-mb-lg text-grey-5">Kampanyalardan ilk sizin haberiniz olsun! Özel indirimleri ve fırsatları kaçırmayın!</p>
              <form class="mc4wp-form" data-name="Subscribe Form Footer">
                <div class="mc4wp-form-fields q-mb-md">
                  <div class="subscribe-inner-form flex items-center">
                    <q-input type="email" color="white" rounded class="q-mr-sm" outlined dark dense name="email" v-model="subscribeEmail" placeholder="E-Posta Adresiniz">
                      <template v-slot:prepend>
                        <q-icon name="mail" size="1.2rem" style="position: relative; top: -1px" class="q-mx-sm" />
                      </template>
                    </q-input>
                    <q-btn round color="secondary" :loading="subscribeLoading" class="subscribe-btn-icon q-pa-none" unelevated @click="newSubscribe">
                      <q-icon name="send" size="1rem" />
                    </q-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="footer-bottom--logo col-md-6 col-sm-6 col-xs-12">
            <a href="/">
              <img src="/img/site-logo-footer.png" alt="Site Logo" width="160" />
            </a>
          </div>
          <div class="footer-bottom--copyright col-md-6 col-sm-6 col-xs-12">
            <p class="copyright-2 m-b0 q-ma-none text-weight-bold">Copyright © 2025 Hazel Jewellery. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- #site-footer -->
</template>

<script lang="ts">
import { defineComponent, inject, ref } from 'vue';
import SubscribeService from 'src/core/services/SubscribeService';
import { useQuasar } from 'quasar';
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'SiteFooter',

  inject: ['currentRoute'],

  computed: {
    isHome() {
      return this.currentRoutePath === '/';
    },
    isNotFound() {
      return this.currentRoute === 404;
    },
    currentRoutePath() {
      return this.$router.currentRoute.value.path;
    },
    footerNav() {
      return this.footer.footerNav;
    },
    siteSocialInfo() {
      return this.header.socialInfo || [];
    },
  },

  setup() {
    const $q = useQuasar();
    const subscribeEmail = ref('');
    const subscribeLoading = ref(false);
    const pageStore = PageStore();
    const { header, footer } = storeToRefs(pageStore);

    const siteAddress = inject<string>('siteAddress');

    return {
      subscribeEmail,
      subscribeLoading,
      siteAddress,
      newSubscribe() {
        subscribeLoading.value = true;
        SubscribeService.newSubscribe({ email: subscribeEmail.value })
          .then(({ status, message }) => {
            if (status._200_) {
              $q.notify({
                type: 'positive',
                message: 'Aboneliğiniz gerçekleştirilmiştir, teşekkür ederiz.',
              });

              subscribeEmail.value = '';
            } else if (String(status)[0] === '4') {
              $q.notify({
                type: 'warning',
                message,
              });
            } else {
              $q.notify({
                type: 'negative',
                message: 'Abonelik gerçekleştirilirken hata meydana geldi, lütfen yakın zamanda tekrar deneyiniz.',
              });
            }
          })
          .finally(() => {
            subscribeLoading.value = false;
          })
          .catch(() => {
            subscribeLoading.value = false;
          });
      },
      header,
      footer,
    };
  },
});
</script>

<style lang="sass" scoped>
#SiteFooter
  background-color: $primary
  color: white

  a
    color: white

  h5
    margin-bottom: .5rem

  ul
    padding-inline-start: 0
    list-style-type: none

    li
      font-size: 1rem
      margin-bottom: .55rem

      a
        text-decoration: none
        transition: .3s
        color: #ccc

        &:hover
          letter-spacing: 1px

  .site-footer--wrapper
    padding: 0 2rem

.footer-bottom
  background-color: white
  margin-top: 2rem
  padding: .4rem 0 .4rem
  color: #0e0e0e

  &--logo
    text-align: center

    @media (min-width: 1024px)
      text-align: left

  &--copyright
    display: flex
    justify-content: center
    align-items: center

    @media (min-width: 1024px)
      justify-content: end

    p
      text-align: center

      @media (min-width: 1024px)
        text-align: right
</style>

<style scoped>
.site-header--social-platforms {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.site-header--social-platforms a.social {
  display: block;
  width: 24px;
  height: 24px;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 1.5rem;
  filter: invert(1);
  transition: 0.3s ease;
}

.site-header--social-platforms a.social:hover {
  transform: scale(1.3);
}

.site-header--social-platforms a.social:last-child {
  margin-right: 0;
}

.site-header--social-platforms a.social.social-facebook {
  width: 25px;
  height: 25px;
}
</style>
